/**
 * @file TrendingList/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 */

import { FireCustomGoal } from "../UserSplitTest/library/goals";

// If no maxItems prop is supplied to the component, this is the maximum
// number of items that will be displayed.
export const DEFAULT_MAX_ITEMS = 5;
export const LAYOUT_HORIZONTAL = "horizontal";
export const LAYOUT_VERTICAL = "vertical";

export const AB_TEST_MARITIMES_TRENDING = {
    agent: "a-qcKMtmTvnJ",
    cardClickHandler: FireCustomGoal(".trendingList .card", "g-wsL6boU3Hx"),
};
